import React from 'react'

import Script from 'dangerous-html/react'
import SEO from '../components/SEO'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './homepage.css'

const Homepage = (props) => {
  return (
    <div className="homepage-container1 teleport-dashboard-layout">
      <SEO
        title="İstanbul Premium Araç Kaplama, PPF & Detailing | ATEŞ AUTO DETAILING"
        description="Beşiktaş Conrad Bosphorus stüdyomuzda kendi kendini yenileyen TPU PPF kaplama, dökme folyo araç kaplama, seramik koruma ve profesyonel oto detailing hizmetleri."
        canonicalPath="/"
      />
      <aside className="homepage-thq-dashboard-sidebar-elm teleport-dashboard-sidebar">
        <Navigation></Navigation>
      </aside>
      <main
        id="tq-main"
        className="homepage-thq-dashboard-content-elm teleport-dashboard-content teleport-dashboard-main"
      >
        <section id="hero" className="hero-studio">
          <div className="hero-studio-carousel">
            <div className="hero-studio-slide active">
              <div className="hero-studio-bg">
                <img
                  loading="eager"
                  decoding="async"
                  src="https://images.pexels.com/photos/6969026/pexels-photo-6969026.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="İstanbul Beşiktaş stüdyosunda lüks araç koruma ve PPF kaplama"
                  fetchpriority="high"
                  className="hero-studio-img"
                />
                <div className="hero-studio-overlay"></div>
              </div>
              <div className="hero-studio-container">
                <div className="hero-studio-meta">
                  <div className="hero-studio-brand-badge">
                    <img
                      src="/logo.png"
                      alt="ATEŞ AUTO DETAILING Logo"
                      className="hero-studio-logo-badge"
                    />
                    <div className="hero-studio-badge-text">
                      <span className="hero-studio-eyebrow">
                        PREMIUM ARAÇ KORUMA &amp; DETAILING
                      </span>
                      <span className="hero-studio-location">
                        BEŞİKTAŞ / İSTANBUL
                      </span>
                    </div>
                  </div>
                </div>
                <h1
                  data-hero-text-recolored="true"
                  className="homepage-thq-hero-title-elm hero-title hero-studio-headline"
                >
                  İSTANBUL&apos;DA<br />
                  PREMİUM ARAÇ<br />
                  KAPLAMA VE PPF
                </h1>
                <div className="hero-studio-content">
                  <p className="hero-studio-support">
                    Aracınızın görünümünü ve boya yüzeyini korumaya yardımcı
                    olan PPF, araç kaplama, boya koruma, seramik kaplama ve
                    profesyonel detailing uygulamaları.
                  </p>
                  <div className="hero-studio-actions">
                    <a href="/iletisim" className="homepage-link10">
                      <div className="btn hero-btn-white hero-btn-teklif">
                        <span>TEKLİF AL</span>
                      </div>
                    </a>
                    <a href="#services" className="homepage-link11">
                      <div className="btn hero-btn-white hero-btn-kesfet">
                        <span>UYGULAMALARI KEŞFET</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="hero-studio-inset">
                  <img
                    loading="eager"
                    decoding="async"
                    src="https://images.pexels.com/photos/30837753/pexels-photo-30837753.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Otomotiv boya yüzeyi kusursuz detailing uygulaması"
                    className="hero-studio-inset-img"
                  />
                  <span className="hero-studio-inset-label">
                    KUSURSUZ DETAYLAR
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="about" className="editorial-intro">
          <div className="editorial-intro-texture"></div>
          <div className="editorial-intro-container">
            <div className="editorial-intro-grid">
              <div className="editorial-intro-media">
                <img
                  loading="eager"
                  decoding="async"
                  src="https://images.pexels.com/photos/6969026/pexels-photo-6969026.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="ATEŞ Auto Detailing profesyonel stüdyo işçiliği ve yüzey hazırlığı"
                  className="editorial-intro-img"
                />
              </div>
              <div className="editorial-intro-text">
                <h2 className="section-title editorial-intro-title">
                  ARACINIZIN GÖRÜNÜMÜNÜ KORUMAK, DETAYDA BAŞLAR.
                </h2>
                <p className="section-content editorial-intro-description">
                  Ateş Auto Detailing, Beşiktaş&apos;ın kalbinde, otomobil
                  tutkusunu teknik hassasiyetle birleştiriyor. Her araç, bizim
                  için bir sanat eseri; her uygulama ise bu eseri koruma altına
                  alan bir imza niteliğindedir. Dünya standartlarında
                  materyaller ve uzman işçilikle, aracınızın ilk günkü
                  ihtişamını yıllar sonrasına taşıyoruz.
                </p>
                <div className="editorial-intro-divider"></div>
              </div>
            </div>
          </div>
        </section>
        <section id="services" className="service-directory">
          <div className="service-directory-grid">
            <a href="/arac-koruma" className="homepage-link12">
              <div className="service-panel">
                <div className="service-panel-bg">
                  <img
                    loading="lazy"
                    decoding="async"
                    src="https://images.pexels.com/photos/31154218/pexels-photo-31154218.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="İstanbul araç koruma ve şeffaf TPU boya koruma filmi"
                    className="service-panel-img"
                  />
                  <div className="service-panel-overlay"></div>
                </div>
                <div className="service-panel-content">
                  <div className="service-panel-header">
                    <span className="service-panel-number">01</span>
                    <h3 className="service-panel-title">ARAÇ KORUMA</h3>
                  </div>
                  <div className="service-panel-footer">
                    <p className="service-panel-desc">
                      PPF, Araç Kaplama, Seramik ve Boya Koruma uygulamaları ile
                      maksimum savunma.
                    </p>
                    <div className="service-panel-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14m-7-7 7 7-7 7"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="/detayli-arac-temizligi" className="homepage-link13">
              <div className="service-panel">
                <div className="service-panel-bg">
                  <img
                    loading="lazy"
                    decoding="async"
                    src="https://images.pexels.com/photos/20042054/pexels-photo-20042054.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Profesyonel iç dış detaylı oto temizlik ve deri bakımı"
                    className="service-panel-img"
                  />
                  <div className="service-panel-overlay"></div>
                </div>
                <div className="service-panel-content">
                  <div className="service-panel-header">
                    <span className="service-panel-number">02</span>
                    <h3 className="service-panel-title">DETAILING</h3>
                  </div>
                  <div className="service-panel-footer">
                    <p className="service-panel-desc">
                      İç ve dış detaylı temizlik, polisaj ve restorasyon ile
                      fabrikasyon kondisyon.
                    </p>
                    <div className="service-panel-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14m-7-7 7 7-7 7"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="/arac-kaplama" className="homepage-link14">
              <div className="service-panel">
                <div className="service-panel-bg">
                  <img
                    loading="lazy"
                    decoding="async"
                    src="https://images.pexels.com/photos/10162529/pexels-photo-10162529.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Premium folyo araç kaplama ve renk değişimi uygulaması"
                    className="service-panel-img"
                  />
                  <div className="service-panel-overlay"></div>
                </div>
                <div className="service-panel-content">
                  <div className="service-panel-header">
                    <span className="service-panel-number">03</span>
                    <h3 className="service-panel-title">RENK DEĞİŞİMİ</h3>
                  </div>
                  <div className="service-panel-footer">
                    <p className="service-panel-desc">
                      Premium folyo seçenekleri ile aracınızın karakterini
                      tamamen yeniden tanımlayın.
                    </p>
                    <div className="service-panel-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14m-7-7 7 7-7 7"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </section>
        <section id="ppf" className="ppf-signature">
          <div className="ppf-signature-shell">
            <div className="ppf-signature-media">
              <img
                loading="lazy"
                decoding="async"
                src="https://images.pexels.com/photos/36021355/pexels-photo-36021355.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Lüks spor araca milimetrik TPU PPF kaplama yapılması"
                className="ppf-signature-img"
              />
              <div className="ppf-signature-overlay"></div>
            </div>
            <div className="ppf-signature-content">
              <span className="ppf-signature-label">SIGNATURE PROTECTION</span>
              <h2 className="section-title ppf-signature-title">
                PPF: BOYANIN ÜZERİNDE GÖRÜNMEYEN BİR KORUMA.
              </h2>
              <p className="ppf-signature-desc">
                PPF, araç yüzeyini yol taşları, küçük darbe etkileri, çizilme ve
                günlük kullanım kaynaklı dış etkenlere karşı korumaya yardımcı
                olan şeffaf boya koruma filmidir. Ateş Auto&apos;da, her panel
                için milimetrik hassasiyetle uygulama yapıyoruz.
              </p>
              <div className="ppf-signature-tags">
                <span className="ppf-tag">PPF KAPLAMA</span>
                <span className="ppf-tag">BOYA KORUMA FİLMİ</span>
                <span className="ppf-tag">ŞEFFAF PPF</span>
                <span className="ppf-tag">TAŞ İZLERİNE KARŞI KORUMA</span>
              </div>
              <a href="/ppf-kaplama" className="homepage-link15">
                <div className="btn btn-outline btn-lg ppf-signature-btn">
                  <span>DETAYLARI İNCELE</span>
                </div>
              </a>
            </div>
          </div>
        </section>
        <section id="results" className="proof-gallery">
          <div className="proof-gallery-container">
            <div className="proof-gallery-header">
              <span className="proof-gallery-eyebrow">MÜKEMMEL SONUÇLAR</span>
              <h2 className="section-title proof-gallery-title">
                UYGULAMA ÖNCESİ VE SONRASI
              </h2>
              <p className="section-content proof-gallery-subtitle">
                Detaylardaki farkı, gerçek projelerimiz üzerinden keşfedin.
              </p>
            </div>
            <div className="proof-gallery-grid">
              <div className="proof-tile featured">
                <img
                  loading="lazy"
                  decoding="async"
                  src="https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Polisaj ve seramik kaplama sonrası ayna yansıması ve pürüzsüz boya"
                  className="proof-tile-img"
                />
                <div className="proof-tile-inset">
                  <img
                    loading="lazy"
                    decoding="async"
                    src="https://images.pexels.com/photos/14542677/pexels-photo-14542677.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Boya düzeltme öncesi yüzeydeki kılcal çizikler ve matlaşma"
                    className="proof-tile-inset-img"
                  />
                  <span className="proof-label">ÖNCE</span>
                </div>
                <span className="proof-label-after">SONRA</span>
              </div>
              <div className="proof-tile">
                <img
                  loading="lazy"
                  decoding="async"
                  src="https://images.pexels.com/photos/6873188/pexels-photo-6873188.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Detaylı araç temizliği sonrası arındırılmış kusursuz iç mekan"
                  className="proof-tile-img"
                />
              </div>
              <div className="proof-tile">
                <img
                  loading="lazy"
                  decoding="async"
                  src="https://images.pexels.com/photos/11139244/pexels-photo-11139244.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Profesyonel pasta cila ve çizik giderme uygulaması sonucu"
                  className="proof-tile-img"
                />
              </div>
              <div className="proof-tile">
                <img
                  loading="lazy"
                  decoding="async"
                  src="https://images.pexels.com/photos/10162528/pexels-photo-10162528.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Özel renk dökme folyo araç kaplama projesi"
                  className="proof-tile-img"
                />
              </div>
              <div className="proof-tile">
                <img
                  loading="lazy"
                  decoding="async"
                  src="https://images.pexels.com/photos/6872572/pexels-photo-6872572.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Deri koltuk arındırma ve besleyici koruma uygulaması"
                  className="proof-tile-img"
                />
              </div>
            </div>
            <div className="proof-gallery-footer">
              <a href="/galeri">
                <div className="btn btn-link">
                  <span>TÜM SONUÇLARI GÖRÜN</span>
                </div>
              </a>
            </div>
          </div>
        </section>
        <section id="contact" className="final-cta-band">
          <div className="final-cta-bg">
            <img
              loading="lazy"
              decoding="async"
              src="https://images.pexels.com/photos/15085608/pexels-photo-15085608.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="ATEŞ Auto Detailing Conrad Istanbul Bosphorus stüdyo ortamı"
              className="final-cta-img"
            />
            <div className="final-cta-overlay"></div>
          </div>
          <div className="final-cta-container">
            <div className="final-cta-content">
              <h2 className="final-cta-headline">
                <span className="homepage-thq-final-cta-line1-elm">
                  ARACINIZ
                </span>
                <span className="homepage-thq-final-cta-line2-elm">
                  DETAYI HAK EDİYOR.
                </span>
              </h2>
              <p className="final-cta-support">
                PPF, araç kaplama, boya koruma, seramik kaplama ve detailing
                uygulamalarını keşfedin.
              </p>
              <div className="final-cta-actions">
                <a href="/iletisim" className="homepage-link17">
                  <div className="btn btn-accent btn-xl">
                    <span>TEKLİF AL</span>
                  </div>
                </a>
                <a
                  href="https://wa.me/905346442153"
                  className="homepage-link18"
                >
                  <div className="btn btn-outline btn-xl whatsapp-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M18.497 4.409a10 10 0 0 1-10.36 16.828l-.223-.098l-4.759.849l-.11.011a1 1 0 0 1-.11 0l-.102-.013l-.108-.024l-.105-.037l-.099-.047l-.093-.058l-.014-.011l-.012-.007l-.086-.073l-.077-.08l-.067-.088l-.056-.094l-.034-.07l-.04-.108l-.028-.128l-.012-.102a1 1 0 0 1 0-.125l.012-.1l.024-.11l.045-.122l1.433-3.304l-.009-.014A10 10 0 0 1 5.056 4.83l.215-.203a10 10 0 0 1 13.226-.217M9.5 7.5A1.5 1.5 0 0 0 8 9v1a6 6 0 0 0 6 6h1a1.5 1.5 0 0 0 0-3h-1l-.144.007a1.5 1.5 0 0 0-1.128.697l-.042.074l-.022-.007a4.01 4.01 0 0 1-2.435-2.435l-.008-.023l.075-.041A1.5 1.5 0 0 0 11 10V9a1.5 1.5 0 0 0-1.5-1.5"></path>
                    </svg>
                    <span>WHATSAPP&apos;TAN ULAŞ</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <div className="homepage-container2">
          <div className="homepage-container3">
            <Script
              html={`<script defer data-name="hero-parallax">
(function(){
  const hero = document.getElementById('hero');
  if (hero) {
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      const rate = scrolled * 0.4;
      const bg = hero.querySelector('.hero-studio-img');
      if (bg) {
        bg.style.transform = \`translate3d(0, \${rate}px, 0)\`;
      }
    });
  }
})()
</script>`}
            ></Script>
          </div>
        </div>
        <div className="homepage-container4">
          <div className="homepage-container5">
            <Script
              html={`<script defer data-name="service-reveal">
(function(){
  const panels = document.querySelectorAll('.service-panel');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        ;
        ;
      }
    });
  }, { threshold: 0.1 });

  panels.forEach(panel => {
    ;
    ;
    ;
    observer.observe(panel);
  });
})()
</script>`}
            ></Script>
          </div>
        </div>
        <Footer></Footer>
      </main>
    </div>
  )
}

export default Homepage
